module.exports = "/images/ISET.png?5dfc3234129f486f0599fdb5d7310b39";